import {MasterOfActsAPI, UserAPI} from "../../api/api";
import {createSuccessNotification, createWarningNotification} from "./notification-reducer";

const SUCCESS_LOAD_USERS = 'usersReducer/SUCCESS_LOAD_USERS'
const ADD_USER = 'usersReducer/ADD_USER'
const CHANGE_USER = 'usersReducer/CHANGE_USER'
const ALL_PROJECT_SUPERVISOR = 'usersReducer/ALL_PROJECT_SUPERVISOR'
const SUPERVISOR_ERROR = 'usersReducer/SUPERVISOR_ERROR'

const initialState = {
    users: [],
    loading: true,
    error: null,
    supervisors: [],
    supervisorsError: null,
}

export const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUCCESS_LOAD_USERS:
            return {...state, users: action.users, loading: false}
        case ADD_USER:
            return {
                ...state, users: [
                    ...state.users,
                    action.user
                ]
            }
        case CHANGE_USER:
            return {
                ...state, users: state.users.map(el => {
                    if (action.user.id === el.id) return action.user
                    return el
                })
            }
        case ALL_PROJECT_SUPERVISOR: 
            return {
                ...state,
                supervisors: action.supervisors
            }
        case SUPERVISOR_ERROR: 
            return {
                ...state,
                supervisorsError: action.error
            }
        default:
            return state
    }
}

export const selectUsers = state => state.usersReducer
export const allProjectSupervisors = state => state.usersReducer.supervisors

export const successLoadUsers = users => ({type: SUCCESS_LOAD_USERS, users})
export const addUser = user => ({type: ADD_USER, user})
export const changeUser = user => ({type: CHANGE_USER, user})
export const loadSupervisors = supervisors => ({type: ALL_PROJECT_SUPERVISOR, supervisors})
export const superError = error => ({type: SUPERVISOR_ERROR, error})

export const loadingUsers = async dispatch => {
    const response = await UserAPI.getUsers(false)

    if (response.status === 200) {
        const users = response.data
        dispatch(successLoadUsers(users))
    }
}

const handleUserErrors = error => dispatch => {
    for (const [field, errorText] of Object.entries(error.response.data)) {
        if (Array.isArray(errorText)) {
            dispatch(createWarningNotification(field + ': ' + errorText.join(' ')))
        }
        if (typeof errorText === 'string') {
            dispatch(createWarningNotification(field + ': ' + errorText))
        }
    }
}

export const createUser = (user, handleClose) => async dispatch => {
    try {
        const userResponse = await UserAPI.createUser({
            ...user,
            is_activated: true
        })

        if (userResponse.status === 201) {
            const response = await UserAPI.patchUser(userResponse.data.id, {
                username: userResponse.data.username,
                contracts: user.contracts
            })
            if (response.status === 200) {
                dispatch(addUser(response.data))
                dispatch(createSuccessNotification('Пользователь успешно создан'))
                handleClose()
            }
        }
    } catch (error) {
        dispatch(handleUserErrors(error))
    }
}

export const patchUser = (user, handleClose) => async dispatch => {
    try {
        const response = await UserAPI.patchUser(user?.id, user)

        if (response.status === 200) {
            dispatch(changeUser(response.data))
            dispatch(createSuccessNotification('Пользователь успешно изменен'))
            handleClose()

        }
    } catch (error) {
        dispatch(handleUserErrors(error))
    }
}

export const loadProjectSupervisor = (contract) => {
    return async(dispatch) => {
        try {
            const supervisorsResponse = await MasterOfActsAPI.getSupervisorProject(contract)
            if (supervisorsResponse.status === 200) {
                dispatch(loadSupervisors(supervisorsResponse.data.supervisors))
            } else dispatch(superError('Ошибка загрузки'))
        } catch(error) {
            dispatch(superError(error))
        }
    }
}